import React from 'react'
import { withRouter, Switch, Redirect } from 'react-router-dom'

import MainNav from 'components/MainNav'

import Home from 'components/Home'
import Article from 'components/Article'
import nSettings from 'components/nSettings'
import { PrivateRoute } from '../../utils/routing'
import cx from 'classnames'

import './style.css'

const App = withRouter(({ location: { pathname } }) => {
  const onSettings = pathname.includes('settings')
  const onEditor = pathname.includes('article')
  
  return (
    <div className="main-app">
      <MainNav onSettings={onSettings} onReports={false} onEditor={onEditor}/>
      <div className={cx({"main-app-content": !onEditor})}>
        <Switch>
          <Redirect exact from='/' to='/category'/>
          <PrivateRoute path="/settings/:settingPage?" component={nSettings}/>
          <PrivateRoute path="/category/:categoryId?/:sectionId?" component={Home}/>
          <PrivateRoute path="/article/:slug+" render={props => <Article {...props} isEditing/>}/>
          <PrivateRoute path="/article" component={Article}/>
        </Switch>
      </div>
    </div>
  )
})

export default App